import { useMemo } from 'react';
import { ILanguage } from 'translations';
import { useTranslation } from 'translations/hooks';

import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import {
  Module_Enum,
  useAvailableCustomIndicatorsQuery,
  ShiftReportGroupByEnum,
} from 'generated/graphql';

export function useAvailableIndicatorSelection(constructionSiteId?: string) {
  const { language } = useTranslation();
  const gqlHeaders = useGraphqlApiHeaders(Module_Enum.ShiftReport);
  const { data, loading, error } = useAvailableCustomIndicatorsQuery({
    variables: { constructionSiteId },
    skip: !constructionSiteId,
    context: {
      headers: gqlHeaders,
    },
  });

  const list = useMemo(() => {
    const indicators:
      | Array<{
          key: string;
          title: string;
          unit: string;
        }>
      | undefined = data?.indicator.map((indicator) => ({
      key: indicator.id,
      title:
        {
          [ILanguage.fr]: indicator.nameFr,
          [ILanguage.enGB]: indicator.nameEn,
          [ILanguage.enUS]: indicator.nameEn,
          [ILanguage.es]: indicator.nameEs,
        }[language] ?? indicator.nameEn,

      unit: indicator.unit,
    }));

    return indicators ?? [];
  }, [data, language]);

  return {
    list,
    loading,
    error,
  };
}

export function getCurrentAnalysisType(
  filteredBy: 'date' | 'ring',
  groupedBy: ShiftReportGroupByEnum,
) {
  if (filteredBy === 'ring') {
    return 'ring';
  }
  switch (groupedBy) {
    case ShiftReportGroupByEnum.Report:
      return 'report';
    case ShiftReportGroupByEnum.Day:
      return 'day';
    case ShiftReportGroupByEnum.Week:
      return 'week';
    case ShiftReportGroupByEnum.Month:
      return 'month';
    default: {
      throw new Error(`group type '${groupedBy}' is invalid.`);
    }
  }
}
